export default __webpack_public_path__ + "static/media/2026_April_Tanz.db74b0a6.webp";